import all from './all';
import destroy from './destroy';
import store from './store';
import update from './update';
import items from './items';

export default {
  all,
  destroy,
  store,
  update,
  items,
};



// WEBPACK FOOTER //
// ./src/app/services/project/index.js